<template>
  <div class="PA-submit">
    <div @submit.prevent="handleSubmit()" class="body">
      <form @submit.prevent ref="form">
        <h2>Ablage Informationen</h2>
        <section>
          <h3>Personal Informationen</h3>
          <SelectAsyncElement ref="async_staff" :readonly="false" :required="true" name="staff" @change="handleStaffSelect" :getOptionDisplayValue="getStaffDisplayValue" label="Personal auswählen" tooltip="Wähle Personal um Informationen automatisch auszufüllen" url="https://www-3.mach.kit.edu/api/public/index.php/api/staff" data_name="staff" :getOptionName="getStaffName"/>
          <div class="subsection">
            <InputElement :readonly="false" ref="input_firstname" :required="true" label="Vorname" name="firstname"/>
            <InputElement :readonly="false" ref="input_lastname" :required="true" label="Nachname" name="lastname"/>
          </div >
          <div class="subsection">
            <InputElement :readonly="false" ref="input_personalnummer" :required="true" label="Personalnummer" name="personalnummer"/>
            <InputElement :readonly="false" ref="input_shib_id" :required="true" label="Kürzel" name="shib_id"/>
          </div>
          <div class="subsection">
            <SelectAsyncElement :getOptionDisplayValue="getInstitutDisplayValue" :getOptionName="getInstitutName" data_name="institute"  url="https://www-3.mach.kit.edu/api/public/index.php/api/institut" class="cols-2" :required="true" label="Institut" name="institut" ref="institut"/>
          </div>
        </section>
        <section>
          <h3>Dokument Informationen</h3>
          <div class="subsection">
            <SelectElement :data="ablage_types" class="cols-2" :required="true" label="Typ" name="type" ref="type"/>
            <InputElement  :required="true" class="cols-2" label="Kurzbeschreibung" name="beschreibung" ref="beschreibung"/>
            <InputElement type="date" :required="true" class="cols-2" label="Datum" name="date" ref="date"/>

          </div>
        </section>
        <input type="hidden" :value="file?JSON.stringify(file.fragments):NULL" name="file" >
        <Button label="Submit" :loading="submit_loading"/>
        <div v-if="response_message">File stored as: {{response_message}}</div>
      </form>
    </div>
  </div>
</template>

<script>
import SelectAsyncElement from '@/components/inputs_23/SelectAsyncElement.vue'
import InputElement from '@/components/inputs_23/InputElement.vue'
import SelectElement from '@/components/inputs_23/SelectElement.vue'
import Button from '@/components/inputs_23/Button.vue'
import axios from "axios";

export default {
  name: 'PASubmit',
  components: {
    SelectAsyncElement,
    InputElement,
    SelectElement,
    Button,
  },
  props: {
    file: Object,
  },
  data() {
    return {
      submit_loading: false,
      ablage_types: [
        {id:0,name:"Type 0"},
        {id:1,name:"Type 1"},
        {id:2,name:"Type 2"},
        {id:3,name:"Type 2"},
        {id:4,name:"Type 2"},
        {id:5,name:"Type 2"},
      ],
      response_message:null,
    }
  },
  methods: {
    clearForm() {
        this.$refs.input_firstname.clear()
        this.$refs.input_lastname.clear()
        this.$refs.input_personalnummer.clear()
        this.$refs.input_shib_id.clear()
        this.$refs.async_staff.clear()
        this.$refs.institut.clear()
        this.$refs.date.clear()

        this.$refs.type.clear()
        this.$refs.beschreibung.clear()
    },
    async handleSubmit() {
      console.log(this.file)
      this.submit_loading = true
      const formData = new FormData(this.$refs.form)
      const request_header = {method:'post',url:this.$store.getters.getApiUrl+`ablage/personal`,data:formData}
      const {data,error} = await axios(request_header).catch(error=>{return {data:null, error}})
      console.log(data,error?.response)
      this.submit_loading = false
      if(error) {
        return
      }
      this.clearForm()
      this.response_message = data.fragment
    },
    handleStaffSelect(staff) {
      if(!staff) {
        this.$refs.input_firstname.clear()
        this.$refs.input_lastname.clear()
        this.$refs.input_personalnummer.clear()
        this.$refs.input_shib_id.clear()
        this.$refs.institut.clear()
        this.$refs.date.clear()

        this.$refs.type.clear()
        this.$refs.beschreibung.clear()
        return
      }
      this.$refs.input_firstname.setValue(staff.firstname)
      this.$refs.input_lastname.setValue(staff.lastname)
      this.$refs.input_personalnummer.setValue(staff.personalnummer)
      this.$refs.input_shib_id.setValue(staff.shib_id)
      this.$refs.institut.setValue(staff.institut_id)
      console.log(staff)
    },
    getInstitutDisplayValue(institut) {
      return `Name: ${institut._data['306']} | Abk: ${institut._data['464']}`
    },
    getInstitutName(institut) {
      return `
        <div style="display:grid;grid-template-columns:1fr 8rem;">
          <div>
            <span style="font-weight:bold;">
              Name: 
            </span>
            <span>
              ${institut._data['306']}
            </span>
          </div>
          <div>
            <span style="font-weight:bold;">
            </span>
            <span>
            </span>
          </div>
          <div>
            <span style="font-weight:bold;">
              Abk: 
            </span>
            <span>
              ${institut._data['464']}
            </span>
          </div>
        </div>
      `
    },
    getStaffDisplayValue(staff) {
      return `Name: ${staff.firstname} ${staff.lastname} | Kürzel: ${staff.shib_id} | Personalnummer: ${staff.personalnummer}`
    },
    getStaffName(staff) {
      return `
        <div style="display:grid;grid-template-columns:1fr 8rem;">
          <div>
            <span style="font-weight:bold;">
              Name: 
            </span>
            <span>
              ${staff.firstname} ${staff.lastname}
            </span>
          </div>
          <div>
            <span style="font-weight:bold;">
              Kürzel: 
            </span>
            <span>
              ${staff.shib_id}
            </span>
          </div>
          <div>
            <span style="font-weight:bold;">
              Personalnummer: 
            </span>
            <span>
              ${staff.personalnummer}
            </span>
          </div>
        </div>
      `
    }
  }
          // <div style="grid-column-start:1;grid-column-end:3;">

}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.PA-submit {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid $text_dark;
  border-radius: 4px;
}
.body {
  width: 100%;
  max-width: 210mm;
}
.subsection {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
.cols-2 {
  grid-column-start: 1;
  grid-column-end: 3;
}
</style>
